import { EyeOff } from 'lucide-react';

import { EmptyState } from '@/components/ui/empty-state';
import { VISIBILITY_COPY } from './visibilityCopy';

/**
 * DV-2861: what a customer sees in place of the photo grid when every
 * photoset on the property is hidden from them. asset-service leaves hidden
 * sets out of a customer's list, so without this the area is blank.
 */
export function PhotosetUnavailable() {
  return (
    <EmptyState
      icon={EyeOff}
      title={VISIBILITY_COPY.unavailableTitle}
      description={
        <>
          {VISIBILITY_COPY.unavailableBody}{' '}
          <a
            href={`mailto:${VISIBILITY_COPY.supportEmail}`}
            className="font-medium text-primary hover:underline"
          >
            {VISIBILITY_COPY.supportEmail}
          </a>
          .
        </>
      }
    />
  );
}
